package com.fireavert.events.active_events.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class GetActiveEventsForPropertyResponse(
    val propertyWithActiveEventsResponse: PropertyWithActiveEventsResponse
)
